import '../styles/recording.css'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GLOBALTYPES } from '../redux/actions/GlobalTypes';
import Shortcut from '../components/Home/Shortcut';
import WithoutLoginNavbar from '../components/WithoutLoginNavbar';
import { create_fingerprint, update_fingerprint_credit } from '../redux/actions/AuthAction';
import Loading from '../components/Loader/Loading';
const OPENAI_KEY = process.env.REACT_APP_OPENAI_KEY


function FreeHome() {
    const credits = useSelector(state => state.fingerprint?.credits)
    const isDarkTheme = useSelector(state => state.theme?.theme)
    const [text, setText] = useState('')
    const creditsLoading = useSelector((state) => state.fingerprint?.loading)

    console.log('creditsLoading', creditsLoading)

    // const [isBlocked, setIsBlocked] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [timer, setTimer] = useState(0);
    const timerRef = useRef(timer);
    const maxRecordingTime = credits; // 5 minutes in seconds
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    // let tempTime = 0
    const dispatch = useDispatch()
    const [textLoading, setTextLoading] = useState(false)
    // const [prompt, setPrompt] = useState("'comma' is ',' and 'dot' is '.' CAR-T cell, DALLE-3,")
    const [prompt, setPrompt] = useState("")

    const [fingerprint, setFingerprint] = useState('');
    const getBrowserFingerprint = async () => {
        // const navigatorInfo = window.navigator;
        // const screenInfo = window.screen;

        // const data = {
        //     userAgent: navigatorInfo.userAgent,
        //     language: navigatorInfo.language,
        //     platform: navigatorInfo.platform,
        //     deviceMemory: navigatorInfo.deviceMemory || 'unknown',
        //     hardwareConcurrency: navigatorInfo.hardwareConcurrency,
        //     colorDepth: screenInfo.colorDepth,
        //     timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        //     sessionStorage: !!window.sessionStorage,
        //     localStorage: !!window.localStorage,
        //     indexedDb: !!window.indexedDB,
        //     cookiesEnabled: navigatorInfo.cookieEnabled,
        // };

        // console.log('data', data)

        // const rawData = Object.values(data).join('::');
        // return sha256(rawData);
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            setFingerprint(data.ip); // Set the fingerprint state
            return data.ip;
        } catch (error) {
            console.error('Error fetching IP:', error);
        }
    };


    useEffect(() => {
        const callFingerPrintApi = async () => {

            if (!fingerprint) {
                const ip = await getBrowserFingerprint();
                dispatch(create_fingerprint(ip))
                setFingerprint(getBrowserFingerprint());
            }
        }

        callFingerPrintApi()

    }, [dispatch, fingerprint]);


    useEffect(() => {

        // if (token) {
        //     dispatch(get_user_credits(token))
        //     if (previousPrompt) {
        //         setPrompt(previousPrompt)
        //     }
        // }
    }, [dispatch])



    useEffect(() => {
        let interval = null;

        if (isRecording) {
            interval = setInterval(() => {
                // tempTime = timer
                setTimer(prevTimer => {
                    if (prevTimer < maxRecordingTime) {
                        timerRef.current = prevTimer + 1;
                        return prevTimer + 1;
                    } else {
                        stopRecording();
                        timerRef.current = prevTimer;
                        return prevTimer;
                    }
                    // const newTimer = prevTimer < maxRecordingTime ? prevTimer + 1 : prevTimer;
                    // timerRef.current = newTimer; // Update the ref
                    // return newTimer;
                });
            }, 1000);
        } else {
            clearInterval(interval);
            // setTimer(0)

            // Reset timer when not recording
        }

        return () => clearInterval(interval);
    }, [isRecording, maxRecordingTime]);
    const toggleRecording = () => {
        if (!isRecording || timer >= maxRecordingTime) {
            startRecording();
        } else {
            stopRecording();
        }
    };

    const transcribeAudio = useCallback(async (audioBlob, timeParameter) => {
        // formData.append('file', audioBlob, 'recording.mp3');
        const formData = new FormData();
        formData.append('file', audioBlob, 'recording.wav');
        let model = 'whisper-1';
        formData.append('model', model)
        formData.append('prompt', prompt)



        try {
            if (credits > 0) {

                setTextLoading(true)

                const response = await fetch('https://api.openai.com/v1/audio/transcriptions', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${OPENAI_KEY}`, // Replace with your API key
                        // 'Content-Type': 'multipart/form-data'
                    },
                    body: formData
                });

                if (response) {
                    const result = await response.json();
                    console.log('result?.text', result?.text)

                    dispatch(await update_fingerprint_credit(timeParameter, fingerprint))
                    setText(result?.text)
                    setTimer(0)
                    setTextLoading(false)
                }
                else {
                    setTextLoading(false)

                    dispatch({
                        type: GLOBALTYPES.ALERT,
                        payload: {
                            error: 'Something went wrong'
                        }
                    })
                    setTimer(0);
                }

            }
            else {
                dispatch({
                    type: GLOBALTYPES.ALERT,
                    payload: {
                        error: 'Please login to use this feature'
                    }
                })
                setTimer(0);
            }
        }
        catch (error) {
            setTimer(0);
            console.error('There was an error calling the Whisper API', error);
            console.log("error", error);
            dispatch({
                type: GLOBALTYPES.ALERT,
                payload: {
                    error: 'Something Went Wrong'
                }
            })
        }
    }, [credits, dispatch, fingerprint, prompt]);

    const startRecording = useCallback(async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            mediaRecorderRef.current = new MediaRecorder(stream);

            mediaRecorderRef.current.ondataavailable = (e) => {
                audioChunksRef.current.push(e.data);
            };

            mediaRecorderRef.current.onstop = async () => {
                // const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' });
                const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' });
                // console.log('audioBlob', audioBlob)
                await transcribeAudio(audioBlob, timerRef.current);
                audioChunksRef.current = [];
            };

            mediaRecorderRef.current.start(1000);
            setIsRecording(true);
        } catch (err) {
            console.error('An error occurred during recording:', err);
            dispatch({
                type: GLOBALTYPES.ALERT,
                payload: {
                    error: err.message
                }
            })

        }

        // Start recording logic
    }, [dispatch, transcribeAudio]);
    const stopRecording = () => {
        // Stop recording logic
        mediaRecorderRef.current.stop();
        const stream = mediaRecorderRef.current?.stream;
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
        setIsRecording(false);

    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (document.activeElement.tagName === 'INPUT') {
                return;
            }
            if (event.key === 'a' || event.key === 'A') {
                startRecording();

            } else if (event.key === 'S' || event.key === 's' || event.key === 'space') {
                stopRecording();

            }
            // else if (event.key === 'd' || event.key === 'D') {
            //     recorderControls.togglePauseResume()
            // }
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [isRecording, startRecording]);


    // navigator.mediaDevices.getUserMedia({ audio: true })
    //     .then(stream => {
    //         // console.log('Permission Granted');
    //         setIsBlocked(false);
    //     })
    //     .catch(error => {
    //         // Handle the error here
    //         if (error.name === 'NotAllowedError') {
    //             // User has blocked the microphone
    //             // console.log('Permission Denied');


    //             dispatch({
    //                 type: GLOBALTYPES.ALERT,
    //                 payload: {
    //                     error: 'Mic Permission was denied'
    //                 }
    //             })
    //             setIsBlocked(true);


    //         }
    //     });


    const handleChange = (e) => {
        setPrompt(
            e.target.value,
        );
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        // setPrompt(prompt)
        dispatch({
            type: GLOBALTYPES.ALERT,
            payload: {
                success: 'Prompt Added Successfully'
            }
        })

    }


    return (
        <>
            <WithoutLoginNavbar />
            {
                creditsLoading ? <Loading /> :
                    <div className='my-4'>

                        <div className='flex flex-col gap-8 items-center w-full mt-10 md:mt-8' >

                            <div className='grid grid-cols-1 md:grid-cols-1 gap-10' >

                                {/* <div className='w-full grid grid-cols-1 h-full max-w-[370px] bg-white border border-gray-200 rounded-lg shadow-md py-[10px] box-showdow-css dark:bg-black'
                        > */}
                                <div className=''
                                >
                                    <Shortcut />


                                </div>
                                {/* </div> */}
                                <div className={`bg-gray-100 max-w-[800px] px-[30px]  rounded-lg flex justify-center items-center flex-col gap-y-5 py-[30px] ${isDarkTheme ? 'box-showdow-css-dark' : 'box-showdow-css'} dark:bg-[#111111]`} >
                                    <form onSubmit={handleSubmit} className='w-[350px] '>

                                        <div className="input-container text-black">
                                            <input type="search" className='text-black' autoComplete='off' autoCorrect='off' id="search" style={{ color: "black" }} placeholder="Type difficult spellings: DALLE3, CRISPR, Joaquin, Saoirse, or etc" onChange={handleChange} value={prompt} />
                                            <button type="submit" className="button">Submit</button>
                                        </div>
                                    </form>

                                    <div className='flex justify-center items-center gap-5 outline-none border-none' >
                                        <button className='bg-white  outline-none rounded-full shadow-lg relative flex  gap-5 p-5' onClick={toggleRecording}>

                                            <svg className='z-[999] outline-none'
                                                fill='black'
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 512 512"
                                            >
                                                <path d="M439.5 236c0-11.3-9.1-20.4-20.4-20.4s-20.4 9.1-20.4 20.4c0 70-64 126.9-142.7 126.9-78.7 0-142.7-56.9-142.7-126.9 0-11.3-9.1-20.4-20.4-20.4s-20.4 9.1-20.4 20.4c0 86.2 71.5 157.4 163.1 166.7v57.5H212c-11.3 0-20.4 9.1-20.4 20.4 0 11.3 9.1 20.4 20.4 20.4h88c11.3 0 20.4-9.1 20.4-20.4 0-11.3-9.1-20.4-20.4-20.4h-23.6v-57.5c91.6-9.3 163.1-80.5 163.1-166.7z" />
                                                <path d="M256 323.5c51 0 92.3-41.3 92.3-92.3V103.3c0-51-41.3-92.3-92.3-92.3s-92.3 41.3-92.3 92.3v127.9c0 51 41.3 92.3 92.3 92.3zm-52.3-220.2c0-28.8 23.5-52.3 52.3-52.3s52.3 23.5 52.3 52.3v127.9c0 28.8-23.5 52.3-52.3 52.3s-52.3-23.5-52.3-52.3V103.3z" />
                                            </svg>
                                        </button>
                                        {isRecording && <span className=" text-black bg-white px-3 py-[7px] shadow-lg rounded-md">
                                            {`${Math.floor(timer / 60).toString().padStart(2, '0')}:${(timer % 60).toString().padStart(2, '0')}`}
                                        </span>}
                                    </div>


                                </div>
                            </div>

                            {text && !textLoading && <div className={`bg-gray-100  max-w-[380px] sm:w-[380px] p-[20px] rounded-lg flex justify-center items-center flex-col gap-5 py-5 text-black  ${isDarkTheme ? 'box-showdow-css-dark' : 'box-showdow-css'} dark:bg-[#111111] dark:text-white`} >

                                {text}

                            </div>
                            }
                            {textLoading && <div className={`bg-gray-100  max-w-[380px] sm:w-[380px] p-[20px] rounded-lg flex justify-center items-center flex-col gap-5 py-5 text-black  ${!isDarkTheme ? 'box-showdow-css' : ''} dark:bg-[#111111] dark:text-white`} >

                                {/* <Circles
                            height="50"
                            width="50"
                            color="rgb(147 51 234)"
                            ariaLabel="circles-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                        /> */}

                            </div>
                            }
                        </div>

                        {/* <div className="absolute  top-0 -z-10 -translate-x-1/2 blur-3xl xl:-top-6" aria-hidden="true">
                    <div
                        className="aspect-[1155/678] w-[20rem] md:w-[72.1875rem] bg-gradient-to-tr from-[#FF80B5] to-[#9089FC] opacity-30"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div> */}
                    </div >
            }

        </>



    )
}

export default FreeHome;